<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>商城</el-breadcrumb-item>
      <el-breadcrumb-item>商品PH与设备分类对照表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <div class="filter">
        <el-form
          :model="filter"
          ref="filterForm"
          label-position="left"
          label-width="70px"
          inline
          size="small"
          @submit.native.prevent
        >
          <el-form-item label="商品 PH">
            <el-input
              v-model="filter.keyword"
              placeholder="PH值"
              @keyup.enter.native="requestSearch"
            ></el-input>
          </el-form-item>
          <el-form-item label="设备分类">
            <item-category-select
              :val="filter.item_category_id"
              :category="2"
              @change="filter.item_category_id = $event"
            ></item-category-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="requestSearch"
              >筛选</el-button
            >
            <el-button size="small" @click="requestSearch('reset')"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="panel mt-20">
      <div class="header" v-permission="Auth.commodityPhManage">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="handleEdit"
          >新增对照</el-button
        >
        <file-button
          obj="commodity_ph"
          style="float: right"
          :filter="filter"
          class="mobile-hide"
          @importCallback="handleImportCallBack"
        ></file-button>
      </div>

      <el-table :data="list" v-loading="loading" stripe style="width: 100%">
        <el-table-column align="left" label="商品 PH" prop="ph">
        </el-table-column>
        <el-table-column align="left" label="设备分类" min-width="200">
          <template slot-scope="scope">
            <div v-for="item in scope.row.item_category_names" :key="item">
              <el-tag type="primary" size="mini">{{
                item.replace(/,/g, '-')
              }}</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="250">
          <template slot-scope="scope">
            <el-popconfirm
              v-permission="Auth.commodityPhManage"
              title="确认删除该对照关系吗？"
              @confirm="handleDelete(scope.$index, scope.row.id)"
            >
              <el-button slot="reference" type="danger" plain size="mini"
                >删除</el-button
              >
            </el-popconfirm>
            <el-button
              v-permission="Auth.commodityPhManage"
              class="ml-5"
              type="primary"
              plain
              size="mini"
              @click="handleEdit(scope.$index, scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20"
        :page-size="filter.size"
        @current-change="handlePageChange"
        :current-page.sync="filter.page"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>

    <ModelFormer
      :model="model"
      :show.sync="itemFormerVisible"
      @created="createdCallback"
      @updated="updatedCallback"
    ></ModelFormer>
  </div>
</template>

<script>
import { commodityPhList, deleteCommodityPh } from '@/service/getData'
import ModelFormer from './former'
import ItemCategorySelect from '@/components/select/item_category_select'

export default {
  components: {
    ModelFormer,
    ItemCategorySelect,
  },
  data() {
    return {
      loading: false,
      model: {},
      itemFormerVisible: false,
      editIndex: 0,
      list: [],
      total: 0,
      filter: {
        size: 20,
        page: 1,
        status: 0,
        keyword: '',
        item_category_id: '',
      },
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      this.loading = true
      let params = this.clone(this.filter)
      params.page -= 1

      let res = await commodityPhList(params)
      if (res.code == 0) {
        this.list = res.data.list
        this.total = res.data.total
        this.loading = false
      }
    },
    handlePageChange(e) {
      this.filter.page = e
      this.getData()
    },
    requestSearch(reset = '') {
      this.filter.page = 1
      if (reset == 'reset') {
        this.filter.status = 0
        this.filter.keyword = ''
        this.filter.item_category_id = ''
      }
      this.getData()
    },
    createdCallback(data) {
      this.list.unshift(data)
    },
    updatedCallback(data) {
      this.$set(this.list, this.editIndex, data)
    },
    handleEdit(index, item) {
      if (item) {
        this.editIndex = index
        this.model = this.clone(item)
      } else {
        this.model = {
          ph: '',
          item_category_ids: [],
        }
      }
      this.itemFormerVisible = true
    },
    async handleDelete(index, id) {
      let res = await deleteCommodityPh(id)
      if (res.code == 0) {
        this.list.splice(index, 1)
      }
    },
    handleImportCallBack(res) {
      this.$message.success(`成功导入${res.data}条数据`)
      this.requestSearch('reset')
    },
  },
}
</script>
